const REMOTE_SERVER = 'https://dabbawalaapi.iosx.in/';
export default REMOTE_SERVER;